export default __webpack_public_path__ + "static/media/blas-pascal-logo.ee281b0c.png";